import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const RotatingTag = ({ words, interval = 2600 }) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const id = setInterval(() => {
            setIndex((prev) => (prev + 1) % words.length);
        }, interval);

        return () => clearInterval(id);
    }, [words.length, interval]);

    return (
        <span className="relative inline-block h-[1.4em] overflow-hidden align-bottom">
            <AnimatePresence mode="wait">
                <motion.span
                    key={words[index]}
                    initial={{ y: '100%', opacity: 0 }}
                    animate={{ y: '0%', opacity: 1 }}
                    exit={{ y: '-100%', opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                    className="block"
                >
                    {words[index]}
                </motion.span>
            </AnimatePresence>
        </span>
    );
};

export default RotatingTag;
